import { useOrgDetails } from '@queries/org'
import { useCreateWalletMutationState } from '@queries/wallet'

export const useBankingServicesDisclaimer = () => {
  const createWalletState = useCreateWalletMutationState()
  const { data: orgDetails } = useOrgDetails()

  const appDisplayName = orgDetails?.data.app_display_name || 'Branch'
  const bankPartnerName = createWalletState?.data?.bank_info?.name
  const fallbackFDIC = `Evolve Bank & Trust, Member FDIC or Lead Bank, Member FDIC`
  const fallbackBankNames = `Evolve Bank & Trust or Lead Bank`

  return `Branch is not a bank. Banking Services provided by ${bankPartnerName ? `${bankPartnerName}, Member FDIC` : fallbackFDIC}. FDIC insurance only applies for eligible accounts should the bank holding your funds fail. The ${appDisplayName} Mastercard Debit Card is issued by ${bankPartnerName || fallbackBankNames} pursuant to a license from Mastercard and may be used everywhere Mastercard debit cards are accepted.`
}
